import React from 'react';
import '../LegalPage/LegalPage.scss';

export default function PrivacyPolicy() {
  return (
    <main className="legal-page">
      <section className="legal-page__hero">
        <p className="legal-page__eyebrow">The Tour Golfers</p>
        <h1>Privacy Policy</h1>
        <p>Effective Date: May 2026</p>
      </section>

      <section className="legal-page__content">
        <p>
          The Tour Golfers (“TTG”, “we”, “our”, or “us”) respects your privacy.
          This Privacy Policy explains how we collect, use, store, and protect
          information when you use our mobile application, website, and related
          services.
        </p>

        <h2>1. Information We Collect</h2>
        <ul>
          <li>Name and email address</li>
          <li>Encrypted account credentials</li>
          <li>Profile images</li>
          <li>Golf scores, rounds, statistics, and handicap-related data</li>
          <li>Comments, likes, reports, blocks, and social interactions</li>
          <li>Friend, group, tournament, and event participation</li>
          <li>Approximate location data for golf yardage and course features</li>
          <li>Device, app, diagnostic, and server log information</li>
        </ul>

        <h2>2. How We Use Information</h2>
        <ul>
          <li>To operate and improve The Tour Golfers platform</li>
          <li>To provide scoring, stats, feed, friend, tournament, and event features</li>
          <li>To authenticate users and protect accounts</li>
          <li>To moderate reports, enforce safety rules, and prevent abuse</li>
          <li>To respond to support requests</li>
          <li>To maintain app security, reliability, and performance</li>
        </ul>

        <h2>3. Location Information</h2>
        <p>
          The app may request approximate location access to support golf-related
          functionality such as yardage calculations and nearby course experiences.
          We do not continuously track your location in the background.
        </p>

        <h2>4. User Content</h2>
        <p>
          Users may create or interact with content including scores, comments,
          likes, profile images, reports, and golf activity. User-generated content
          may be visible to other members depending on platform features and privacy
          settings.
        </p>

        <h2>5. Moderation and Safety</h2>
        <p>
          Users may report content or block other users directly in the app.
          Reported content may be reviewed, hidden, removed, or used to enforce
          platform safety rules.
        </p>

        <h2>6. Data Sharing</h2>
        <p>
          We do not sell personal information. We may share limited information
          with trusted service providers that help us operate the platform, including
          hosting, infrastructure, analytics, diagnostics, and security providers.
        </p>

        <h2>7. Account Deletion</h2>
        <p>
          Users may permanently delete their account directly within the app from
          the Edit Profile section. Account deletion removes or anonymizes associated
          profile data, scores, rounds, comments, likes, notifications, social
          relationships, and related account activity, unless retention is legally
          required.
        </p>

        <h2>8. Data Security</h2>
        <p>
          We use reasonable safeguards including password hashing, protected API
          routes, JWT authentication, rate limiting, server access controls, and
          secure infrastructure practices. No electronic system can be guaranteed
          completely secure.
        </p>

        <h2>9. Children’s Privacy</h2>
        <p>
          The Tour Golfers is not intended for children under 13 years old. We do
          not knowingly collect personal information from children under 13.
        </p>

        <h2>10. Your Rights</h2>
        <p>
          Depending on your location, you may have rights to access, correct, or
          delete your personal information. You may contact us using the email below.
        </p>

        <h2>11. Changes to This Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. Updated versions will
          be posted on this page.
        </p>

        <h2>12. Contact</h2>
        <p>
          Privacy questions can be sent to{' '}
          <a href="mailto:privacy@thetourgolfers.com">privacy@thetourgolfers.com</a>.
        </p>
      </section>
    </main>
  );
}